export interface EmailSettings {
  signature: string | null;
  email: string | null;
  expirationDate: Date;
  sendOptOutRequest: boolean;
  customOptOutMessage: string | null;
  delaySeconds?: number;
  windowHours?: number;
}

export enum EmailIntegrationType {
  GMAIL = 'GMail',
  OUTLOOK = 'Outlook',
  CUSTOM = 'Custom',
}
